import { Component } from "@angular/core";

@Component({
  selector: "app-confirmation-alert-dialog",
  templateUrl: "./confirmation-alert-dialog.component.html",
})
export class ConfirmationAlertDialogComponent {}
